import {z} from 'zod';

export const queueCountsResponseSchema = z.object({
  status: z.string(),
  data: z.object({
    visible: z.number(),
    inFlight: z.number(),
  }),
  timestamp: z.string(),
});
